import { Button, InputLabel, TextField, Typography } from "@mui/material";
import { Box, styled } from "@mui/system";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const labelStyles = { mb: 1, mt: 2, fontSize: "24px", fontWeight: "bold", fontFamily: '"Press Start 2P"', color: '#FFD700' };

const StyledTextField = styled(TextField)({
  fontFamily: '"Press Start 2P"',
  margin: '10px 0',
  '& label.Mui-focused': {
    color: '#FFD700',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#FFD700',
    },
    '&:hover fieldset': {
      borderColor: '#FF8E53',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#FFD700',
    },
  },
});

const StyledButton = styled(Button)({
    marginTop: '16px',
    padding: '10px 15px',
    background: '#FF8E53', // Retro color for the button
    color: 'black',
    fontFamily: '"Press Start 2P"',
    '&:hover': {
      background: '#FE6B8B',
    },
  });
const UpdateBlog = () => {
  const navigate = useNavigate();
  const [blog, setBlog] = useState();
  const id = useParams().id;
  console.log(id);
  const [inputs, setInputs] = useState({});
  const handleChange = (e) => {
    setInputs((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };
  const fetchDetails = async () => {
    const res = await axios
      .get(`https://retroheaven.cyclic.app/api/blog/getblog/${id}`)
      .catch((err) => console.log(err));
    const data = await res.data;
    return data;
  };
  useEffect(() => {
    fetchDetails().then((data) => {
      setBlog(data.blog);
      setInputs({
        title: data.blog.title,
        description: data.blog.description,
      });
    });
  }, [id]);
  const sendRequest = async () => {
    const res = await axios
      .put(`https://retroheaven.cyclic.app/api/blog/update/${id}`, {
        title: inputs.title,
        description: inputs.description,
      })
      .catch((err) => console.log(err));

    const data = await res.data;
    return data;
  };
  console.log(blog);
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(inputs);
    sendRequest()
      .then((data) => console.log(data))
      .then(() => navigate("/myBlogs/"));
  };

  return (
    <div>
      {inputs && (
        <form onSubmit={handleSubmit}>
          <Box
            border={3}
            borderColor="linear-gradient(90deg, rgba(58,75,180,1) 2%, rgba(116,49,110,1) 36%, rgba(2,0,161,1) 73%, rgba(69,92,252,1) 100%)"
            borderRadius={10}
            boxShadow="10px 10px 20px #ccc"
            padding={3}
            margin={"auto"}
            marginTop={3}
            display="flex"
            flexDirection={"column"}
            width={"80%"}
          >
            <Typography
              fontWeight={"bold"}
              padding={3}
              variant="h2"
              textAlign={"center"}
              sx={{ fontFamily: '"Press Start 2P"', color: '#FFD700' }}
            >
              Update Your Blog
            </Typography>
            <InputLabel sx={labelStyles}>Title</InputLabel>
            <StyledTextField
              name="title"
              onChange={handleChange}
              value={inputs.title}
              variant="outlined"
              fullWidth
            />
            <InputLabel sx={labelStyles}>Description</InputLabel>
            <StyledTextField
              name="description"
              onChange={handleChange}
              value={inputs.description}
              multiline
              rows={4}
              variant="outlined"
              fullWidth
            />
            <StyledButton type="submit" variant="contained">
              Update
            </StyledButton>
          </Box>
        </form>
      )}
    </div>
  );
};

export default UpdateBlog;